webpackJsonp([0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var platform_browser_dynamic_1 = __webpack_require__(1);
	var app_module_1 = __webpack_require__(23);
	platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule);


/***/ },

/***/ 23:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var platform_browser_1 = __webpack_require__(21);
	var forms_1 = __webpack_require__(24);
	var http_1 = __webpack_require__(28);
	var app_component_1 = __webpack_require__(29);
	var app_routing_1 = __webpack_require__(35);
	var home_component_1 = __webpack_require__(66);
	var about_component_1 = __webpack_require__(68);
	var term_component_1 = __webpack_require__(70);
	var privacy_component_1 = __webpack_require__(72);
	var AppModule = (function () {
	    function AppModule() {
	    }
	    return AppModule;
	}());
	AppModule = __decorate([
	    core_1.NgModule({
	        declarations: [
	            app_component_1.AppComponent,
	            home_component_1.HomeComponent,
	            about_component_1.AboutComponent,
	            term_component_1.TermComponent,
	            privacy_component_1.PrivacyComponent
	        ],
	        imports: [
	            platform_browser_1.BrowserModule,
	            forms_1.FormsModule,
	            http_1.HttpModule,
	            http_1.JsonpModule,
	            app_routing_1.routing
	        ],
	        providers: [app_routing_1.appRoutingProviders],
	        bootstrap: [app_component_1.AppComponent]
	    }),
	    __metadata("design:paramtypes", [])
	], AppModule);
	exports.AppModule = AppModule;


/***/ },

/***/ 29:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	__webpack_require__(30);
	var AppComponent = (function () {
	    function AppComponent() {
	    }
	    AppComponent.prototype.ngOnInit = function () {
	        console.log('AppComponent initializing...');
	    };
	    return AppComponent;
	}());
	AppComponent = __decorate([
	    core_1.Component({
	        selector: 'my-app',
	        template: __webpack_require__(34)
	    }),
	    __metadata("design:paramtypes", [])
	], AppComponent);
	exports.AppComponent = AppComponent;


/***/ },

/***/ 30:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 34:
/***/ function(module, exports) {

	module.exports = "<div class=\"header-container\">\r\n    <header>\r\n        <h1 class=\"title\">Tailcode GK</h1>\r\n    </header>\r\n</div>\r\n\r\n<div class=\"main-container\">\r\n    <router-outlet></router-outlet>\r\n</div>\r\n\r\n<div class=\"footer-container\">\r\n    <footer>\r\n        <a routerLink=\"/\">TOP</a>\r\n        | <a routerLink=\"/about\" routerLinkActive=\"active\">会社概要</a>\r\n        | <a routerLink=\"/privacy\" routerLinkActive=\"active\">プライバシーポリシー</a>\r\n        | <a routerLink=\"/term\" routerLinkActive=\"active\">利用規約・免責</a>\r\n        <span>&copy; 2016 Tailcode GK All rights reserved.</span>\r\n    </footer>\r\n</div>\r\n";

/***/ },

/***/ 35:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var router_1 = __webpack_require__(36);
	var home_component_1 = __webpack_require__(66);
	var about_component_1 = __webpack_require__(68);
	var term_component_1 = __webpack_require__(70);
	var privacy_component_1 = __webpack_require__(72);
	var appRoutes = [
	    { path: '', component: home_component_1.HomeComponent },
	    { path: 'about', component: about_component_1.AboutComponent },
	    { path: 'term', component: term_component_1.TermComponent },
	    { path: 'privacy', component: privacy_component_1.PrivacyComponent }
	];
	exports.appRoutingProviders = [];
	exports.routing = router_1.RouterModule.forRoot(appRoutes);


/***/ },

/***/ 66:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var HomeComponent = (function () {
	    function HomeComponent() {
	    }
	    return HomeComponent;
	}());
	HomeComponent = __decorate([
	    core_1.Component({
	        selector: 'home',
	        template: __webpack_require__(67)
	    }),
	    __metadata("design:paramtypes", [])
	], HomeComponent);
	exports.HomeComponent = HomeComponent;


/***/ },

/***/ 67:
/***/ function(module, exports) {

	module.exports = "<div>\r\n    <h3>Tailcode GK</h3>\r\n    <div class=\"resource\">\r\n        <h4>合同会社テイルコード</h4>\r\n        <p>テイルコードはアプリケーション・システム開発を通してみなさまに価値を提供します。</p>\r\n    </div>\r\n\r\n    <div class=\"resource\">\r\n        <h4>このサイトについて</h4>\r\n        <p>このサイトはAngular2 + webpackで作られました。</p>\r\n    </div>\r\n\r\n    <div class=\"resource\">\r\n      <h4>GACTアプリについて</h4>\r\n      <p>サポートメールアドレス：app.gact@tailcode.io</p>\r\n      <p>質問、ご要望等、お気軽にご連絡ください</p>\r\n    </div>\r\n</div>\r\n";

/***/ },

/***/ 68:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var AboutComponent = (function () {
	    function AboutComponent() {
	    }
	    return AboutComponent;
	}());
	AboutComponent = __decorate([
	    core_1.Component({
	        selector: 'about',
	        template: __webpack_require__(69)
	    }),
	    __metadata("design:paramtypes", [])
	], AboutComponent);
	exports.AboutComponent = AboutComponent;


/***/ },

/***/ 69:
/***/ function(module, exports) {

	module.exports = "<div>\r\n  <div class=\"resource\">\r\n    <h1>会社概要</h1>\r\n    <h4>概要</h4>\r\n    <dl>\r\n      <dt>商号</dt>\r\n      <dd>合同会社テイルコード</dd>\r\n\r\n      <dt>設立</dt>\r\n      <dd>平成２８年１２月１２日</dd>\r\n\r\n      <dt>ホームページ</dt>\r\n      <dd>http://tailcode.io/</dd>\r\n\r\n      <dt>事業内容</dt>\r\n      <dd>\r\n        <ul>\r\n          <li>モバイルアプリの開発・リリース</li>\r\n          <li>Webシステムの開発・運用・保守</li>\r\n          <li>Webアプリケーションの開発・運用・保守</li>\r\n        </ul>\r\n      </dd>\r\n\r\n      <dt>関係会社</dt>\r\n      <dd>株式会社GACT</dd>\r\n    </dl>\r\n\r\n    <h1>事業内容・商品紹介</h1>\r\n    <p>弊社は、モバイルアプリケーションの開発を行っています。</p>\r\n    <dl>\r\n      <dt>GACT アプリ</dt>\r\n      <dd>\r\n        <p>遺伝子検査の結果から、個別に日々のエクササイズをサポートするモバイルアプリです。</p>\r\n        <p>iOS、Androidに両対応。ハイブリッドアプリとして並行開発しています。</p>\r\n        <p>近日、各アプリストアにてリリース予定です。</p>\r\n\r\n        <img class=\"app-screen\" src=\"/images/app/gact-screen1.png\">\r\n        <img class=\"app-screen\" src=\"/images/app/gact-screen2.png\">\r\n      </dd>\r\n    </dl>\r\n  </div>\r\n</div>\r\n";

/***/ },

/***/ 70:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var TermComponent = (function () {
	    function TermComponent() {
	    }
	    return TermComponent;
	}());
	TermComponent = __decorate([
	    core_1.Component({
	        selector: 'term',
	        template: __webpack_require__(71)
	    }),
	    __metadata("design:paramtypes", [])
	], TermComponent);
	exports.TermComponent = TermComponent;


/***/ },

/***/ 71:
/***/ function(module, exports) {

	module.exports = "<div>\n  <div class=\"resource\">\n    <h1>利用規約</h1>\n    <p>この利用規約（以下，「本規約」といいます。）は，合同会社テイルコード（以下，「当社」といいます。）がこのサイト上で提供するサービス（以下，「本サービス」といいます。）の利用条件を定めるものです。ユーザーの皆さま（以下，「ユーザー」といいます。）には，本規約に従って，本サービスをご利用いただきます。</p>\n\n    <h2>第1条（適用）</h2>\n    <p>本規約は，ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。</p>\n\n    <h2>第2条（利用登録）</h2>\n    <ul>\n      <li>登録希望者が当社の定める方法によって利用登録を申請し，当社がこれを承認することによって，利用登録が完了するものとします。</li>\n      <li>当社は，利用登録の申請者に以下の事由があると判断した場合，利用登録の申請を承認しないことがあり，その理由については一切の開示義務を負わないものとします。\n        <ul>\n          <li>（1）利用登録の申請に際して虚偽の事項を届け出た場合</li>\n          <li>（2）本規約に違反したことがある者からの申請である場合</li>\n          <li>（3）その他，当社が利用登録を相当でないと判断した場合</li>\n        </ul>\n      </li>\n    </ul>\n\n    <h2>第3条（ユーザーIDおよびパスワードの管理）</h2>\n    <ul>\n      <li>ユーザーは，自己の責任において，本サービスのユーザーIDおよびパスワードを管理するものとします。</li>\n      <li>ユーザーは，いかなる場合にも，ユーザーIDおよびパスワードを第三者に譲渡または貸与することはできません。当社は，ユーザーIDとパスワードの組み合わせが登録情報と一致してログインされた場合には，そのユーザーIDを登録しているユーザー自身による利用とみなします。</li>\n    </ul>\n\n    <h2>第4条（利用料金および支払方法）</h2>\n    <ul>\n      <li>ユーザーは，本サービス利用の対価として，当社が別途定め，本サイトに表示する利用料金を，当社が指定する方法により支払うものとします。</li>\n      <li>ユーザーが利用料金の支払を遅滞した場合には，ユーザーは年１４．６％の割合による遅延損害金を支払うものとします。</li>\n    </ul>\n\n    <h2>第5条（禁止事項）</h2>\n    <p>ユーザーは，本サービスの利用にあたり，以下の行為をしてはなりません。</p>\n    <ul class=\"child\">\n      <li>（1）法令または公序良俗に違反する行為</li>\n      <li>（2）犯罪行為に関連する行為</li>\n      <li>（3）当社のサーバーまたはネットワークの機能を破壊したり，妨害したりする行為</li>\n      <li>（4）当社のサービスの運営を妨害するおそれのある行為</li>\n      <li>（5）他のユーザーに関する個人情報等を収集または蓄積する行為</li>\n      <li>（6）他のユーザーに成りすます行為</li>\n      <li>（7）当社のサービスに関連して，反社会的勢力に対して直接または間接に利益を供与する行為</li>\n      <li>（8）その他，当社が不適切と判断する行為</li>\n    </ul>\n\n    <h2>第6条（本サービスの提供の停止等）</h2>\n    <ul>\n      <li>当社は，以下のいずれかの事由があると判断した場合，ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。\n        <ul>\n          <li>（1）本サービスにかかるコンピュータシステムの保守点検または更新を行う場合</li>\n          <li>（2）地震，落雷，火災，停電または天災などの不可抗力により，本サービスの提供が困難となった場合</li>\n          <li>（3）コンピュータまたは通信回線等が事故により停止した場合</li>\n          <li>（4）その他，当社が本サービスの提供が困難と判断した場合</li>\n        </ul>\n      </li>\n      <li>当社は，本サービスの提供の停止または中断により，ユーザーまたは第三者が被ったいかなる不利益または損害について，理由を問わず一切の責任を負わないものとします。</li>\n    </ul>\n\n    <h2>第7条（利用制限および登録抹消）</h2>\n    <ul>\n      <li>当社は，以下の場合には，事前の通知なく，ユーザーに対して，本サービスの全部もしくは一部の利用を制限し，またはユーザーとしての登録を抹消することができるものとします。\n        <ul>\n          <li>（1）本規約のいずれかの条項に違反した場合</li>\n          <li>（2）登録事項に虚偽の事実があることが判明した場合</li>\n          <li>（3）その他，当社が本サービスの利用を適当でないと判断した場合</li>\n        </ul>\n      </li>\n      <li>当社は，本条に基づき当社が行った行為によりユーザーに生じた損害について，一切の責任を負いません。</li>\n    </ul>\n\n    <h2>第8条（免責事項）</h2>\n    <ul>\n      <li>当社の債務不履行責任は，当社の故意または重過失によらない場合には免責されるものとします。</li>\n      <li>当社は，何らかの理由によって責任を負う場合にも，通常生じうる損害の範囲内かつ有料サービスにおいては代金額（継続的サービスの場合には1か月分相当額）の範囲内においてのみ賠償の責任を負うものとします。</li>\n      <li>当社は，本サービスに関して，ユーザーと他のユーザーまたは第三者との間において生じた取引，連絡または紛争等について一切責任を負いません。</li>\n    </ul>\n\n    <h2>第9条（サービス内容の変更等）</h2>\n    <p>当社は，ユーザーに通知することなく，本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし，これによってユーザーに生じた損害について一切の責任を負いません。</p>\n\n    <h2>第10条（利用規約の変更）</h2>\n    <p>当社は，必要と判断した場合には，ユーザーに通知することなくいつでも本規約を変更することができるものとします。</p>\n\n    <h2>第11条（通知または連絡）</h2>\n    <p>ユーザーと当社との間の通知または連絡は，当社の定める方法によって行うものとします。</p>\n\n    <h2>第12条（権利義務の譲渡の禁止）</h2>\n    <p>ユーザーは，当社の書面による事前の承諾なく，利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し，または担保に供することはできません。</p>\n\n    <h2>第13条（準拠法・裁判管轄）</h2>\n    <ul>\n      <li>本規約の解釈にあたっては，日本法を準拠法とします。</li>\n      <li>本サービスに関して紛争が生じた場合には，当社の本店所在地を管轄する裁判所を専属的合意管轄とします。</li>\n    </ul>\n\n    <p class=\"tR\">以上</p>\n\n  </div> \n\n</div>\n";

/***/ },

/***/ 72:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var PrivacyComponent = (function () {
	    function PrivacyComponent() {
	    }
	    return PrivacyComponent;
	}());
	PrivacyComponent = __decorate([
	    core_1.Component({
	        selector: 'privacy',
	        template: __webpack_require__(73)
	    }),
	    __metadata("design:paramtypes", [])
	], PrivacyComponent);
	exports.PrivacyComponent = PrivacyComponent;


/***/ },

/***/ 73:
/***/ function(module, exports) {

	module.exports = "<div>\n  <div class=\"resource\">\n    <h1>プライバシーポリシー</h1>\n    <p>合同会社テイルコード（以下，「当社」といいます。）は，本サイト上で提供するサービス（以下,「本サービス」といいます。）におけるプライバシー情報の取扱いについて，以下のとおりプライバシーポリシー（以下，「本ポリシー」といいます。）を定めます。</p>\n    <h2>第1条（プライバシー情報）</h2>\n    <ul>\n      <li>プライバシー情報のうち「個人情報」とは，個人情報保護法にいう「個人情報」を指すものとし，生存する個人に関する情報であって，当該情報に含まれる氏名，生年月日，住所，電話番号，連絡先その他の記述等により特定の個人を識別できる情報を指します。</li>\n      <li>プライバシー情報のうち「履歴情報および特性情報」とは，上記に定める「個人情報」以外のものをいい，ご利用いただいたサービスやご購入いただいた商品，ご覧になったページや広告の履歴，ユーザーが検索された検索キーワード，ご利用日時，ご利用の方法，ご利用環境，郵便番号や性別，職業，年齢，ユーザーのIPアドレス，クッキー情報，位置情報，端末の個体識別情報などを指します。</li>\n    </ul>\n\n    <h2>第２条（プライバシー情報の収集方法）</h2>\n    <ul>\n      <li>当社は，ユーザーが利用登録をする際に氏名，生年月日，住所，電話番号，メールアドレス，銀行口座番号，クレジットカード番号，運転免許証番号などの個人情報をお尋ねすることがあります。また，ユーザーと提携先などとの間でなされたユーザーの個人情報を含む取引記録や，決済に関する情報を当社の提携先（情報提供元，広告主，広告配信先などを含みます。以下，｢提携先｣といいます。）などから収集することがあります。</li>\n      <li>当社は，ユーザーについて，利用したサービスやソフトウエア，購入した商品，閲覧したページや広告の履歴，検索した検索キーワード，利用日時，利用方法，利用環境（携帯端末を通じてご利用の場合の当該端末の通信状態，利用に際しての各種設定情報なども含みます），IPアドレス，クッキー情報，位置情報，端末の個体識別情報などの履歴情報および特性情報を，ユーザーが当社や提携先のサービスを利用しまたはページを閲覧する際に収集します。</li>\n    </ul>\n\n    <h2>第３条（個人情報を収集・利用する目的）</h2>\n    <p>当社が個人情報を収集・利用する目的は，以下のとおりです。</p>\n    <ul class=\"child\">\n      <li>（1）ユーザーに自分の登録情報の閲覧や修正，利用状況の閲覧を行っていただくために，氏名，住所，連絡先，支払方法などの登録情報，利用されたサービスや購入された商品，およびそれらの代金などに関する情報を表示する目的</li>\n      <li>（2）ユーザーにお知らせや連絡をするためにメールアドレスを利用する場合やユーザーに商品を送付したり必要に応じて連絡したりするため，氏名や住所などの連絡先情報を利用する目的</li>\n      <li>（3）ユーザーの本人確認を行うために，氏名，生年月日，住所，電話番号，銀行口座番号，クレジットカード番号，運転免許証番号，配達証明付き郵便の到達結果などの情報を利用する目的</li>\n      <li>（4）ユーザーに代金を請求するために，購入された商品名や数量，利用されたサービスの種類や期間，回数，請求金額，氏名，住所，銀行口座番号やクレジットカード番号などの支払に関する情報などを利用する目的</li>\n      <li>（5）ユーザーが簡便にデータを入力できるようにするために，当社に登録されている情報を入力画面に表示させたり，ユーザーのご指示に基づいて他のサービスなど（提携先が提供するものも含みます）に転送したりする目的</li>\n      <li>（6）代金の支払を遅滞したり第三者に損害を発生させたりするなど，本サービスの利用規約に違反したユーザーや，不正・不当な目的でサービスを利用しようとするユーザーの利用をお断りするために，利用態様，氏名や住所など個人を特定するための情報を利用する目的</li>\n      <li>（7）ユーザーからのお問い合わせに対応するために，お問い合わせ内容や代金の請求に関する情報など当社がユーザーに対してサービスを提供するにあたって必要となる情報や，ユーザーのサービス利用状況，連絡先情報などを利用する目的</li>\n      <li>（8）上記の利用目的に付随する目的</li>\n    </ul>\n\n    <h2>第４条（個人情報の第三者提供）</h2>\n    <ul>\n      <li>当社は，次に掲げる場合を除いて，あらかじめユーザーの同意を得ることなく，第三者に個人情報を提供することはありません。ただし，個人情報保護法その他の法令で認められる場合を除きます。\n        <ul>\n          <li>（1）法令に基づく場合</li>\n          <li>（2）人の生命，身体または財産の保護のために必要がある場合であって，本人の同意を得ることが困難であるとき</li>\n          <li>（3）公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって，本人の同意を得ることが困難であるとき</li>\n          <li>（4）国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって，本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき</li>\n          <li>（5）予め次の事項を告知あるいは公表をしている場合\n            <ol>\n              <li>利用目的に第三者への提供を含むこと</li>\n              <li>第三者に提供されるデータの項目</li>\n              <li>第三者への提供の手段または方法</li>\n              <li>本人の求めに応じて個人情報の第三者への提供を停止すること</li>\n            </ol>\n          </li>\n        </ul>\n      </li>\n      <li>前項の定めにかかわらず，次に掲げる場合は第三者には該当しないものとします。\n        <ul>\n          <li>（1）当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合</li>\n          <li>（2）合併その他の事由による事業の承継に伴って個人情報が提供される場合</li>\n          <li>（3）個人情報を特定の者との間で共同して利用する場合であって，その旨並びに共同して利用される個人情報の項目，共同して利用する者の範囲，利用する者の利用目的および当該個人情報の管理について責任を有する者の氏名または名称について，あらかじめ本人に通知し，または本人が容易に知り得る状態に置いているとき</li>\n        </ul>\n      </li>\n    </ul>\n\n    <h2>第５条（個人情報の開示）</h2>\n    <ul>\n      <li>当社は，本人から個人情報の開示を求められたときは，本人に対し，遅滞なくこれを開示します。ただし，開示することにより次のいずれかに該当する場合は，その全部または一部を開示しないこともあり，開示しない決定をした場合には，その旨を遅滞なく通知します。なお，個人情報の開示に際しては，１件あたり１，０００円の手数料を申し受けます。\n        <ul>\n          <li>（1）本人または第三者の生命，身体，財産その他の権利利益を害するおそれがある場合</li>\n          <li>（2）当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合</li>\n          <li>（3）その他法令に違反することとなる場合</li>\n        </ul>\n      </li>\n      <li>前項の定めにかかわらず，履歴情報および特性情報などの個人情報以外の情報については，原則として開示いたしません。</li>\n    </ul>\n\n    <h2>第６条（個人情報の訂正および削除）</h2>\n    <ul>\n      <li>ユーザーは，当社の保有する自己の個人情報が誤った情報である場合には，当社が定める手続きにより，当社に対して個人情報の訂正または削除を請求することができます。</li>\n      <li>当社は，ユーザーから前項の請求を受けてその請求に応じる必要があると判断した場合には，遅滞なく，当該個人情報の訂正または削除を行い，これをユーザーに通知します。</li>\n    </ul>\n\n    <h2>第７条（個人情報の利用停止等）</h2>\n    <p>当社は，本人から，個人情報が，利用目的の範囲を超えて取り扱われているという理由，または不正の手段により取得されたものであるという理由により，その利用の停止または消去（以下，「利用停止等」といいます。）を求められた場合には，遅滞なく必要な調査を行い，その結果に基づき，個人情報の利用停止等を行い，その旨本人に通知します。ただし，個人情報の利用停止等に多額の費用を有する場合その他利用停止等を行うことが困難な場合であって，本人の権利利益を保護するために必要なこれに代わるべき措置をとれる場合は，この代替策を講じます。</p>\n\n    <h2>第８条（プライバシーポリシーの変更）</h2>\n    <ul>\n      <li>本ポリシーの内容は，ユーザーに通知することなく，変更することができるものとします。</li>\n      <li>当社が別途定める場合を除いて，変更後のプライバシーポリシーは，本サイトに掲載したときから効力を生じるものとします。</li>\n    </ul>\n\n    <!--\n    <h2>第９条（お問い合わせ窓口）</h2>\n    <p>本ポリシーに関するお問い合わせは，下記の窓口までお願いいたします。</p>\n    <p>住所：<br>\n    社名：<br>\n    担当部署：<br>\n    Eメールアドレス：</p>\n    -->\n    <p class=\"\">以上</p> \n\n  </div>\n\n</div>\n";

/***/ }

});


// WEBPACK FOOTER //
// app.js